import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { getDetailsdata } from '../../api'
import img_home from '../../img_2/home.png'
import getNum from '../../method/method'
import starsScore from '../../method/start'
import './Details2.css'
import { insert_adv, remove_adv } from '../../method/addadv'
import Footer from '../Hometwo/Footer/Footer'
import { iframeLoad } from '../../method/analytics'

export default function Details() {
  const [data, setData] = useState({})
  const [dataarr, setDataarr] = useState([])
  const [imgdata, setImgdata] = useState([])
  const { search } = useLocation()
  // console.log(search);

  // 跳转详情
  // const goDetails = (para) => {
  //   window.location = "/page/details?gid=" + para
  //   getdata("?gid=" + para)
  //   window.scrollTo(0, 0)
  // }

  // const playgame = (__url) => {
  //   window.location = __url
  // }

  useEffect(() => {
    const getdata = para => {
      getDetailsdata(para).then(res => {
        // console.log(res.data);
        setData(res.data)
        setDataarr(res.data.recommend)
        setImgdata(res.data.preview)
      })
    }

    getdata(search)

    if ((window.law_ntv_ad1, window.law_ntv_ad2)) {
      insert_adv('adv_1')
      insert_adv('adv_2')
      var pageLoadSecond = new Date().getTime()
      iframeLoad(pageLoadSecond)

      return () => {
        remove_adv('adv_1')
        remove_adv('adv_2')
      }
    }
  }, [search])

  /* 返回上一页 */
  const goback = () => {
    window.location = '/'
  }

  return (
    <div className="details details2">
      <div className="deta-head">
        <img src={img_home} alt="" onClick={goback} />
      </div>

      {/* 下载量详情 */}
      <div className="de-title">
        {/* left */}
        <div className="tit-left">
          <img src={process.env.REACT_APP_BASEURL + data.icon} alt="" />
          <div className="de-content">
            <h3 className="game-n">{data.name}</h3>
            <span>Hot Game</span>
            {/* <p style={{ color: 'blueviolet' }}>Author：{data.author}</p> */}
            <p>
              {starsScore(data.score)} {data.score}
            </p>
          </div>
        </div>

        {/* right */}
        <div className="tit-right">
          <p>
            <span>{getNum(data.count)}</span> player
          </p>
        </div>
      </div>

      {/* 广告一 */}
      <div className="adv_box">
        <p>advertisement</p>
        <div id="adv_1" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad1 }}></div>
      </div>

      {/* gamebtn */}
      <div className="btn-box">
        <a href={data.link} className="dis_a">
          <button className="de-btn">PLAY</button>
        </a>
      </div>

      {/* gamedetails */}
      <div className="game-content">
        <h2>Preview</h2>

        <div className="img-view">
          {imgdata?.map(item => (
            <img src={process.env.REACT_APP_BASEURL + item} key={item} alt="" /* onClick={() => img_dis(item)} */ className="list_img" />
          ))}
        </div>
      </div>

      <h2 className="desc">Description</h2>
      <p>{data.description}</p>

      <div className="gl-content">
        <h1>You might like.</h1>
        {/* 游戏列表区 */}
        <div>
          {dataarr?.map(item => (
            <div key={item.gid} className="newgame_content">
              <a href={'/page/details?gid=' + item.gid} className="dis_a">
                <img src={process.env.REACT_APP_BASEURL + item.icon} alt="" />
                <div className="new_con">
                  <h4>{item.name}</h4>
                  <p className="gametype">
                    {starsScore(item.score)} {item.score}
                  </p>
                  <p className="playnum">{item.count / 1000}k+</p>
                </div>
                <div className="play">PLAY GAME</div>
              </a>
            </div>
          ))}
        </div>
      </div>

      {/* 广告二 */}
      <div className="adv_box">
        <p>advertisement</p>
        <div id="adv_2" dangerouslySetInnerHTML={{ __html: window.law_ntv_ad2 }}></div>
      </div>

      <Footer></Footer>
    </div>
  )
}
